
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1000 1000"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 290"}},[_c('g',{attrs:{"data-name":"Group 286"}},[_c('path',{attrs:{"data-name":"Path 123","d":"M499.91 1000C259.73 999.73 65.1 805.1 64.83 564.92c.27-240.18 194.9-434.81 435.08-435.08 240.17.27 434.81 194.9 435.08 435.08-.27 240.18-194.91 434.81-435.08 435.08zm0-784.16c-192.79.16-349 156.41-349.2 349.19.16 192.79 156.41 349 349.2 349.2 192.79-.16 349-156.41 349.19-349.2-.16-192.78-156.4-349.03-349.19-349.19z"}})]),_c('g',{attrs:{"data-name":"Group 287"}},[_c('path',{attrs:{"data-name":"Path 124","d":"M655.23 714.24l-191.11-118V336.18h71.66v220.05l157.08 96.94z"}})]),_c('g',{attrs:{"data-name":"Group 288"}},[_c('path',{attrs:{"data-name":"Rectangle 294","d":"M672.986 71.352l45.58-73.1 276.429 172.361-45.58 73.1z"}})]),_c('g',{attrs:{"data-name":"Group 289"}},[_c('path',{attrs:{"data-name":"Rectangle 295","d":"M5.579 172.516L281.282.036l45.611 72.909L51.19 245.425z"}})])])])
          )
        }
      }
    